import { Helmet } from 'react-helmet'
import { useState, useEffect } from 'react'


import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Container from 'react-bootstrap/Container'

import DepartmentBuilder from '../../Components/Planner/Rotations/DepartmentBuilder'
import PositionBuilder from '../../Components/Planner/Rotations/PositionBuilder'
import ResidentBuilder from '../../Components/Planner/Rotations/ResidentBuilder'
import RotationBuilder from '../../Components/Planner/Rotations/RotationBuilder'

export default function RotationsPlanner( props )
{ 
    const [ activeKey, setActiveKey ] = useState("departments")

    return (
        <>
            <Helmet>
                <title> Manager | Daily Planner </title>
            </Helmet>

            <Container style={{ height:'calc(100vh - 60px)', maxWidth:'1200px', padding:'10px', overflowY:'scroll'}}> 
                <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k)} justify>
                    <Tab eventKey="positions" title="Positions">
                        <PositionBuilder activeKey={activeKey}/>
                    </Tab>
                    <Tab eventKey="rotations" title="Rotations">
                        <RotationBuilder activeKey={activeKey}/>
                    </Tab>


                </Tabs>
            </Container>
        </>
    )
}

